const KEY = 'mailservice-auth-token';

export const set = (token) => {
  window.sessionStorage.setItem(KEY, token);
};

export const get = () => window.sessionStorage.getItem(KEY);

export const has = () => {
  const token = get();
  return !!token && token !== 'undefined';
};

export const destroy = () => {
  window.sessionStorage.removeItem(KEY);
};



// WEBPACK FOOTER //
// ./src/services/auth/token.js